import { CheckIcon, CloseIcon, EditIcon } from "@chakra-ui/icons";
import { Flex, Input, Text, useColorModeValue } from "@chakra-ui/react";
import React, { useState } from "react";
import { NumberWithCommas } from "utils";

interface AmountDisplayProps {
  amount: number;
  currencySymbol?: string;
  onUpdate?: (newAmount: number) => void;
}

function AmountDisplay({
  amount,
  currencySymbol = "$",
  onUpdate,
}: AmountDisplayProps) {
  const textColor = useColorModeValue("gray.700", "white");
  const [value, setValue] = useState<string>(amount.toString());
  const [isEditing, setEditing] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;

    if (/^\d*\.?\d*$/.test(inputValue)) {
      setValue(inputValue);
    }
  };

  return (
    <Flex gap={2} alignItems="center">
      {isEditing ? (
        <Flex gap={2}>
          <Input size="sm" value={value} type="text" onChange={handleChange} />
        </Flex>
      ) : (
        <Text color={textColor} fontSize="sm" fontWeight="500">
          {currencySymbol}
          {NumberWithCommas(amount)}
        </Text>
      )}
      {onUpdate ? (
        isEditing ? (
          <Flex alignItems="center">
            <CloseIcon
              cursor="pointer"
              boxSize={3}
              ml={2}
              onClick={() => setEditing(false)}
            />
            <CheckIcon
              cursor="pointer"
              boxSize={3.5}
              ml={2}
              onClick={() => {
                const newValue = parseFloat(value);
                if (!isNaN(newValue)) {
                  onUpdate(newValue);
                }
                setEditing(false);
              }}
            />
          </Flex>
        ) : (
          <EditIcon
            cursor="pointer"
            boxSize={3}
            ml={2}
            onClick={() => setEditing(true)}
          />
        )
      ) : null}
    </Flex>
  );
}

export default AmountDisplay;
